import React from 'react';
import { Star, MapPin, Clock, Users } from 'lucide-react';
import { Store } from '../types';
interface StoreCardProps {
  store: Store;
  onClick: () => void;
  variant?: 'default' | 'compact' | 'featured';
  showCheckIn?: boolean;
  onCheckIn?: (e: React.MouseEvent) => void;
  onPeekInside?: (e: React.MouseEvent) => void;
  onImHere?: (e: React.MouseEvent) => void;
}
export function StoreCard({
  store,
  onClick,
  variant = 'default',
  showCheckIn,
  onCheckIn,
  onPeekInside,
  onImHere
}: StoreCardProps) {
  if (variant === 'compact') {
    return <div onClick={onClick} className="flex-shrink-0 w-40 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden active:scale-95 transition-transform cursor-pointer" data-id="element-1916">
        <div className="h-24 bg-gray-200 relative overflow-hidden" data-id="element-1917">
          <img src={store.image} alt={store.name} className="w-full h-full object-cover" onError={e => {
          e.currentTarget.style.display = 'none';
        }} data-id="element-1918" />
          <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm px-1.5 py-0.5 rounded-lg flex items-center gap-1 shadow-sm" data-id="element-1919">
            <Star size={10} className="text-yellow-500 fill-yellow-500" data-id="element-1920" />
            <span className="text-[10px] font-bold" data-id="element-1921">{store.rating}</span>
          </div>
        </div>
        <div className="p-3" data-id="element-1922">
          <h3 className="font-bold text-gray-900 text-sm truncate" data-id="element-1923">
            {store.name}
          </h3>
          <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-1" data-id="element-1924">
            <MapPin size={10} data-id="element-1925" /> {store.distance}
          </p>
        </div>
      </div>;
  }
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition-all" data-id="element-1926">
      <div onClick={onClick} className="cursor-pointer active:scale-[0.98] transition-transform" data-id="element-1927">
        <div className="h-32 bg-gray-200 relative overflow-hidden" data-id="element-1928">
          <img src={store.image} alt={store.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={e => {
          e.currentTarget.style.display = 'none';
        }} data-id="element-1929" />
          <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-lg flex items-center gap-1 shadow-sm" data-id="element-1930">
            <Star size={12} className="text-yellow-500 fill-yellow-500" data-id="element-1931" />
            <span className="text-xs font-bold" data-id="element-1932">{store.rating}</span>
          </div>
          <div className="absolute bottom-3 left-3 flex flex-col gap-1.5 items-start" data-id="element-1933">
            {store.hasGatheringSpot && <div className="bg-[#FFFC00] text-black px-2 py-1 rounded-lg flex items-center gap-1 shadow-sm border border-black/10" data-id="element-1934">
                <Users size={10} strokeWidth={3} data-id="element-1935" />
                <span className="text-[10px] font-bold uppercase tracking-tight" data-id="element-1936">
                  Gathering Spot
                </span>
              </div>}
            {store.tags[0] && <div className="bg-black/60 backdrop-blur-sm px-2 py-1 rounded-lg" data-id="element-1937">
                <span className="text-[10px] font-medium text-white" data-id="element-1938">
                  {store.tags[0]}
                </span>
              </div>}
          </div>
        </div>
        <div className="p-4" data-id="element-1939">
          <div className="flex justify-between items-start mb-2" data-id="element-1940">
            <div data-id="element-1941">
              <h3 className="font-bold text-gray-900 text-lg leading-tight" data-id="element-1942">
                {store.name}
              </h3>
              <div className="flex items-center gap-3 mt-1 text-sm text-gray-500" data-id="element-1943">
                <span className="flex items-center gap-1" data-id="element-1944">
                  <MapPin size={12} data-id="element-1945" /> {store.distance}
                </span>
                <span className="flex items-center gap-1" data-id="element-1946">
                  <Clock size={12} data-id="element-1947" /> {store.hours.split('-')[0]}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dual Button System */}
      {showCheckIn && <div className="px-4 pb-4 flex gap-3" data-id="element-1948">
          <button onClick={e => {
        e.stopPropagation();
        onPeekInside?.(e);
      }} className="flex-1 bg-[#E6FF00] text-black py-2.5 rounded-xl font-semibold text-sm hover:bg-[#CCFF00] transition-all active:scale-95" data-id="element-1949">
            Peek Inside
          </button>

          <button onClick={e => {
        e.stopPropagation();
        onImHere?.(e);
      }} className="flex-1 bg-[#FFFC00] text-black py-2.5 rounded-xl font-semibold text-sm hover:bg-[#F7C300] transition-all active:scale-95" data-id="element-1950">
            I'm Here
          </button>
        </div>}
    </div>;
}